import React, { useState, useRef } from 'react';
import { useSearch } from './help/useSearch';
import SearchResult from './search_result.js';
import NoResult from './noresult.js';
import { useTranslation } from 'react-i18next';


const cmsUrl = process.env.REACT_APP_CMS_URL_ASSETS;

const SearchBox = ({ AuthService, category, isLogged, setIsLoginModalOpen }) => {
  const user_id = AuthService.getCustom('user_id');
  const { t } = useTranslation();
  const {
    searchQuery,
    setSearchQuery,
    searchResults,
    loading,
    gameCount,
    noResult,
    handleSearch,
    loadMore,
  } = useSearch(category, 5, AuthService);

  const loaderRef = useRef();
  const scrollContainerRef = useRef();

  const [providerDropdownOpen, setProviderDropdownOpen] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState('Provider...');

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    handleSearch(value, 1, false);
  };

  const toggleProviderDropdown = () => {
    setProviderDropdownOpen((prevState) => !prevState);
  };

  const selectProvider = (providerName) => {
    setSelectedProvider(providerName);
    setProviderDropdownOpen(false);
  };

  const getProviderIcon = (providerslug) => {
    return `${cmsUrl}static-assets/providers/${providerslug}.png`;
};
  return (
    <div
      className="box-casino-search"
      ref={scrollContainerRef}
      
    >
      <div className="single-search width-100-d">
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder={t("Search_games") + "..."}
            aria-label="Search"
            value={searchQuery}
            onChange={handleInputChange}
          />
          <span className="input-group-text">
            <svg
              viewBox="0 0 14 14"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              className="icon icon-search sm margin square"
            >
              <path d="M10.027 8.624c.033.025.064.053.094.083l2.829 2.829a1 1 0 01-1.414 1.414L8.707 10.12a1.01 1.01 0 01-.083-.094 5.5 5.5 0 111.403-1.403zM5.5 9a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"></path>
            </svg>
          </span>
        </div>
      </div>




      {searchQuery && !noResult && (
        <>
          <SearchResult
            searchResults={searchResults}
            loading={loading}
            game_count={gameCount}
            getProviderIcon={getProviderIcon}
            AuthService={AuthService}
            isLogged={isLogged}
            setIsLoginModalOpen={setIsLoginModalOpen}
          />
          <div ref={loaderRef} style={{ height: '1px', background: 'transparent' }}></div>
        </>
      )}

      {noResult && <NoResult />}

      {loading && (
        <div style={{ textAlign: 'center', padding: '10px' }}>Loading...</div>
      )}
    </div>
  );
};

export default SearchBox;
